import * as React from 'react'
import cc from 'classcat'
import Image from 'gatsby-image'

import s from './styles.module.css'

export default class DecoratedImage extends React.Component {
  render() {
    const { img, className } = this.props

    return (
      <div className={cc([s.container, className])}>
        <div className={s.decoration} />
        <Image
          className={s.image}
          outerWrapperClassName={s.imageWrapper}
          sizes={img.sizes}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DecoratedImage/index.js